import { render, staticRenderFns } from "./AggiungiCodiceSdi.vue?vue&type=template&id=bded08f4"
import script from "./AggiungiCodiceSdi.vue?vue&type=script&lang=js"
export * from "./AggiungiCodiceSdi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports